module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-upload-fill-8dd768e4.svg";